/* eslint-disable */
import { Component, OnInit } from '@angular/core';
/* eslint-enable */

@Component({
  selector: 'app-loading-spinner',
  templateUrl: 'loading-spinner.component.html'
})
export class LoadingSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
